import axios from 'axios';

// Helper function to get X-Forwarded-Host header
const getForwardedHost = (apiUrl: string): string => {
  // If apiUrl is missing or empty, use window.location.host
  if (!apiUrl) {
    return window.location.host;
  }
  
  // For relative URLs (starting with /), use window.location.host directly
  if (apiUrl.startsWith("/")) {
    return window.location.host;
  }
  
  // For absolute URLs, parse them to extract the host
  try {
    const parsedUrl = new URL(apiUrl);
    // Ensure we always return a valid host, fallback to window.location.host if empty
    return parsedUrl.host || window.location.host;
  } catch (error) {
    // If parsing fails, fallback to window.location.host
    return window.location.host;
  }
};

export const getTotalStats = async (
	startDate: Date,
	endDate: Date,
): Promise<any> => {
	// format should be: 2024-01-01, i.e YYYY-MM-DD
	const startDateStr = startDate.toISOString().split('T')[0];
	const endDateStr = endDate.toISOString().split('T')[0];

	const API_URL = `/api3.2/sales-analytics/getTotalOutbounds?startDate=${startDateStr}&endDate=${endDateStr}`;

	try {
		const response = await axios.get<any>(API_URL, {
      headers: {
        "X-Forwarded-Host": getForwardedHost(API_URL),
      },
    });
		return response.data;
	} catch (error) {
		console.error('Error fetching visit stats:', error);
		throw error;
	}
};

